var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupChatUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 5.12879C9.29643 5.00701 9.96372 4.26391 9.96559 3.36362C9.96559 2.47638 9.31879 1.74074 8.47069 1.60156",
    stroke: "#E99940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57422 7.21289C10.4136 7.3384 10.9995 7.63228 10.9995 8.23807C10.9995 8.65497 10.7237 8.92587 10.2776 9.09611",
    stroke: "#E99940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70244 7.4707C2.70552 7.4707 1 7.77329 1 8.98175C1 10.1896 2.69496 10.5009 4.70244 10.5009C6.69936 10.5009 8.40425 10.2014 8.40425 8.99231C8.40425 7.78323 6.70992 7.4707 4.70244 7.4707Z",
    stroke: "#E99940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70096 5.74563C6.01132 5.74563 7.07377 4.6838 7.07377 3.37282C7.07377 2.06245 6.01132 1 4.70096 1C3.3906 1 2.32814 2.06245 2.32814 3.37282C2.32317 4.67883 3.37755 5.74128 4.68356 5.74563H4.70096Z",
    stroke: "#E99940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatUsers);
export default __webpack_public_path__ + "static/media/GroupChatUsers.e3157881775d184def4858c25e48c85d.svg";
export { ForwardRef as ReactComponent };